import { select } from "redux-saga/effects";

import { IStoreState } from "../../../reducers/types";
import { IPopulateTripQueryParams } from "../actions/actions";
import * as H from "history";
import queryStringParser from "query-string";
import { getTripId, getTripsFilter } from "../reducer";
import { PATH_HOME } from "../../../utils/paths";
import { getIsTravelApp } from "@capone/common";

export interface ITripParsedQuery {
  tripId: string;
  tripsFilter: string;
  isTravelApp: string | string[] | null;
}

export function* populateTripQueryParamsSaga({
  history,
  queryParams,
}: IPopulateTripQueryParams) {
  const state: IStoreState = yield select();
  populateTripQueryParametersFromState(state, history, queryParams);
}

export const populateTripQueryParametersFromState = (
  state: IStoreState,
  history: H.History,
  queryParams?: { tripId?: string }
) => {
  const queryParamsTripId = queryParams?.tripId;

  const { tripId, tripsFilter } = getExistingStateVariables(state);

  const queryString = parseQueryString(history);

  if (
    isOnTripsListPath(history.location.pathname) &&
    stateDiffersFromQueryParams(state, queryString)
  ) {
    const { isTravelApp } = getIsTravelApp();
    const newQuery = { tripsFilter, isTravelApp: isTravelApp || undefined };

    if (queryParamsTripId || tripId) {
      newQuery["tripId"] = queryParamsTripId ?? tripId;
    }

    const location = {
      pathname: PATH_HOME,
      search: queryStringParser.stringify(newQuery),
    };

    history.push(location);
  }

  return queryString;
};

const isOnTripsListPath = (pathname: string) =>
  pathname === PATH_HOME || pathname === PATH_HOME.slice(0, -1);

export function getExistingStateVariables(state: IStoreState) {
  return {
    tripsFilter: getTripsFilter(state),
    tripId: getTripId(state),
  };
}

export const parseQueryString = (history: H.History): ITripParsedQuery => {
  const queryString = history?.location?.search || "";

  const parsedQueryStringPrimitive = queryStringParser.parse(queryString);
  return {
    tripsFilter: parsedQueryStringPrimitive.tripsFilter as unknown as string,
    tripId: parsedQueryStringPrimitive.tripId as string,
    isTravelApp: parsedQueryStringPrimitive.isTravelApp,
  };
};

export function stateDiffersFromQueryParams(
  state: IStoreState,
  parsedQueryString: ITripParsedQuery
) {
  const { tripsFilter, tripId } = getExistingStateVariables(state);

  const diffTripsFilter =
    !parsedQueryString.tripsFilter ||
    parsedQueryString.tripsFilter !== tripsFilter;
  const diffTripId =
    !parsedQueryString.tripId || parsedQueryString.tripId !== tripId;

  return !!(diffTripsFilter || diffTripId);
}
